var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4747_171565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z",
    fill: "#F7B500",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7362 8C11.7362 10.1442 11.275 12.0607 10.5538 13.4229C9.8208 14.8075 8.894 15.5 8.00092 15.5C7.10784 15.5 6.18104 14.8075 5.44801 13.4229C4.72682 12.0607 4.26562 10.1442 4.26562 8C4.26562 5.85576 4.72682 3.93933 5.44801 2.57709C6.18104 1.19248 7.10784 0.5 8.00092 0.5C8.894 0.5 9.8208 1.19248 10.5538 2.57709C11.275 3.93933 11.7362 5.85576 11.7362 8Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68359 5.39941C1.68359 5.39941 4.65573 6.51396 7.99938 6.51396C11.343 6.51396 14.3152 5.39941 14.3152 5.39941",
    stroke: "black",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 2.42725C3.91406 2.42725 5.40013 3.5418 8.00075 3.5418C10.6014 3.5418 12.0874 2.42725 12.0874 2.42725",
    stroke: "black",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 13.5726C3.91406 13.5726 5.40013 12.458 8.00075 12.458C10.6014 12.458 12.0874 13.5726 12.0874 13.5726",
    stroke: "black",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01562 10.9724C2.01562 10.9724 4.65543 9.48633 7.999 9.48633C11.3426 9.48633 13.9824 10.9724 13.9824 10.9724",
    stroke: "black",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0.941406V15.0591",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4747_171565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.43974c3851dda08b613276d7572214ba.svg";
export { ForwardRef as ReactComponent };